import {useTranslation} from "react-i18next";

export default function SurveyButton(
    {
        id
    }
) {
    const { t } = useTranslation();

    return (
        <a href={`/conference/${id}/survey`} className="btn-conference-page btn-primary">
            { t('conferences.conference.buttons.rate') }
        </a>
    );
}
